import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import QuestionOld from "../oldDesign/Questions/QuestionOld";
import Question from "../Questions/Question";
import { shouldSendWithSendBTN, shouldShowSendButton, shouldCompleted, shouldFeedbackType } from "../utils";
import classes from './QuestionnaireViewer.module.css';
export const MAX_RETRIES = 2;

const quetionsDesignComponentEnum = {
    old: QuestionOld,
    new: Question
}
const QuestionnaireViewer = ({
    data,
    contentDirPath,
    lessonId,
    postAnswer,
    onlyView,
    scoreByRetries,
    oldDesign,
    remindSendBtn,
    handleChangeQuestions
}) => {

    const [disableButton, setDisableButton] = useState(true)
    const [sendInProgress, setSendInProgress] = useState(false)
    const { texts } = useSelector(state => state.translate);


    useEffect(() => {
        if (data.quetions?.find(q => q.changed)) {
            const bounceElement = document.getElementById("SendBTN");
            bounceElement?.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [remindSendBtn])

    useEffect(() => {
        data.quetions?.map(q => {
            if (q.changed)
                setDisableButton(false)
        })
    }, [])

    const handleChangeAnsData = (ansData) => {
        const currentQuestion = data.quetions.find(q => q.id === ansData.id)
        if (currentQuestion) {
            ansData.solution !== null ?
                !currentQuestion.statusObject.autoSend && setDisableButton(false) : setDisableButton(true)
            const updateQuestion = {
                ...currentQuestion,
                ansData: { ...ansData },
                feedback: { ...currentQuestion.feedback, show: false },
                changed: true
            }
            handleChangeQuestions(updateQuestion)
            if (currentQuestion.statusObject.autoSend) {
                setSendInProgress(true)
                handlePostAnswer(updateQuestion)
                setSendInProgress(false)
            }
        }
    }

    const handleSendAnswers = async () => {
        if (!onlyView) {
            setDisableButton(true)
            for (let i = 0; i < data.quetions.length; i++) {
                if (shouldSendWithSendBTN(data.quetions[i])) {
                    setSendInProgress(true)
                    await handlePostAnswer(data.quetions[i])
                    setSendInProgress(false)
                }
            }
        }
    }

    const handlePostAnswer = async (question) => {
        if (postAnswer) {
            await postAnswer(question.id, question);
        }
        updateQuestionAfterSubmit(question);
    }

    const updateQuestionAfterSubmit = (question) => {
        const updateQuestion = {
            ...question,
            changed: false,
            ansData: {},
            submission: question.submission ? {
                ...question.submission,
                score: question.ansData.score,
                solution: question.ansData.solution,
                success: question.ansData.success,
                attempts: question.submission.attempts + 1,
            } : {
                assessmentExternalId: question.ansData.id,
                score: question.ansData.score,
                solution: question.ansData.solution,
                success: question.ansData.success,
                attempts: 0,
            },
        };
        updateQuestion.completed = shouldCompleted(updateQuestion, MAX_RETRIES);
        updateQuestion.feedback = shouldFeedbackType(updateQuestion, MAX_RETRIES);
        handleChangeQuestions(updateQuestion)
    }

    return <div className={classes.QuestionnaireViewer} style={data && data.bgImage ? { backgroundImage: `url(${contentDirPath}${data.bgImage.url})`, ...data.bgImage } : {}}>
        {data.video &&
            (data.video.isFile ?
                <video
                    className={classes.Video}
                    src={`${contentDirPath}${data.video.url}`}
                    style={{ ...data.video, position: 'absolute' }}
                    controls /> :
                <iframe
                    className={classes.Video}
                    src={data.video.url}
                    style={{ ...data.video, position: 'absolute' }}
                    frameBorder="0"
                    allowFullScreen></iframe>)
        }
        <div className={classes.QuestionList} style={data.style}>
            {data.quetions && data.quetions.map((q, index) => {
                const QuestionComponent = quetionsDesignComponentEnum[oldDesign ? 'old' : 'new']
                return <QuestionComponent
                    {...q}
                    key={q.id}
                    postAnswer={postAnswer}
                    sendInProgress={sendInProgress}
                    index={index + 1}
                    contentDirPath={contentDirPath}
                    lessonId={lessonId}
                    scoreByRetries={scoreByRetries}
                    handleChangeAnsData={handleChangeAnsData}
                ></QuestionComponent>
            })}

            {data.quetions && shouldShowSendButton(data.quetions) && <button id='SendBTN' className={`${classes.AnsBtn} ${remindSendBtn && classes.BounceElement}`} disabled={disableButton} onClick={handleSendAnswers}>{texts.send}</button>}
        </div>
    </div>
}

export default QuestionnaireViewer;